/** Строгий BFF/CSRF transport, общий для release-trust и грантов appliance. */
import apiClient from "./client";

const currentByDefault = () => true;
const rejectResponse = () => new Error("HUB не подтвердил операцию с разрешением установки");

/** Принимает только ожидаемый HTTP-статус и успешный unified envelope. */
export async function requestData(config, status = 200) {
  const response = await apiClient(config);
  const body = response?.data;
  if (response?.status !== status || !body || typeof body !== "object" ||
      !Object.prototype.hasOwnProperty.call(body, "data") || body.error !== null) {
    throw rejectResponse();
  }
  return body.data;
}

/** Получает свежий CSRF без storage/cache; утративший контекст запрос не выдаёт результат. */
export async function mutateWithCsrf({ url, data, status, csrfUrl, current = currentByDefault }) {
  if (!current()) throw rejectResponse();
  const csrf = await requestData({ url: csrfUrl, method: "GET" });
  if (!current() || typeof csrf?.csrf_token !== "string" ||
      !/^[a-zA-Z0-9_-]{1,256}$/.test(csrf.csrf_token)) throw rejectResponse();
  const result = await requestData({ url, method: "POST", data, headers: { "X-CSRFToken": csrf.csrf_token } }, status);
  if (!current()) throw rejectResponse();
  return result;
}
